import { Button, ButtonProps, ConfigProvider } from 'antd';
import clsx from 'clsx';
import { ArrowLeft } from 'lucide-react';
import { CSSProperties } from 'react';
import { theme } from 'styles/colors';

export const darkButtonStyles: CSSProperties = {
  padding: '1.2rem 2rem',
  border: 'none',
  borderRadius: '6rem',
  // background: '#242425',
  // color: 'white',
  boxShadow: 'none'
};

const buttonDisabledStyles: CSSProperties = {
  background: '#F0F1F5',
  color: theme.primary,
  border: '1px solid #E4E6EB'
};

export function BaseButton(props: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBg: theme.primary,
            defaultColor: 'white',
            /**
             * AntD theme overriding is opinionated. Based on seed tokens the library calculates colours for other component types
             * `colorPrimary` is the main seed token.
             *
             * The opinionated design of AntD makes it tedious to customize. The team plans to replace this with tailwind components
             */
            colorPrimary: theme.primary
          }
        }
      }}
    >
      <Button
        type="primary"
        {...props}
        className={clsx('crx-typography', props.className)}
        style={{
          ...darkButtonStyles,
          ...(props.disabled && buttonDisabledStyles),
          ...props.style
        }}
      />
    </ConfigProvider>
  );
}

export const QuestionnaireGreyButton = (props: ButtonProps) => (
  <BaseButton
    {...props}
    style={{
      background: theme.grey.light,
      color: 'black',
      ...props.style
    }}
  />
);

export const BackButton2 = (props: ButtonProps) => (
  <BaseButton {...props} icon={<ArrowLeft />} />
);
